import React from 'react';
import usePagebuilder from '../../../../../hooks/pagebuilder/usePagebuilder';
import useMobileView from '../../../../../hooks/useMobileView';
import { ALL_COMPONENTS_INTERSECTION_TYPE, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import { AdjustableSizeWrapper } from '../../../pageBuilder/AdjustableSizeWrapper';
import AgendaUIComponent from './AgendaUiComponent/AgendaUiComponent';
import AppointmentBookingUiComponent from './AppointmentBookingUiComponent';
import BoothLogos from './BoothLogosUiComponent';
import BoothsUiComponent from './BoothsUiComponent';
import ChallengeComponent from './ChallengeUiComponent';
import ColumnUiComponent from './ColumnComponent';
import CountdownComponent from './CountdownUiComponent';
import CTAButtonUiComponent from './CTAButtonUiComponent';
import DividerUiComponent from './DividerUiComponent';
import EventHomeComponent from './EventHomeComponent';
import EventsListUiComponent from './EventsListUIComponent';
import GalleryComponent from './GalleryUiComponent'; // deprecated and moved to image component
import HeroMenuUiComponent from './HeroMenuUiComponent';
import HTMLComponent from './HTMLUiComponent';
import ImageUiComponent from './ImageUiComponent';
import InfoBoothUiComponent from './InfoBoothUiComponent';
import MarginComponent from './MarginUiComponent';
import AllMatchesUiComponent from './MatchingUiComponent';
import MediaUiComponent from './MediaUiComponent';
import NetworkComponent from './NetworkUiComponent';
import PhotoBoothUiComponent from './PhotoBoothUiComponent';
import PollUiComponent from './PollUiComponent';
import PresentationPreviewList from './PresentationPreviewListUiComponent';
import PresentationUiComponent from './PresentationUiComponent';
import QAUiComponent from './QAUiComponent';
import QueueComponent from './QueueUiComponent';
import SignupFormComponent from './SignupFormUiComponent';
import SocialMediaComponent from './SocialMediaUiComponent';
import SpeakersUiComponent from './SpeakersUiComponent/SpeakersUiComponent';
import SpeedDatingUiComponent from './SpeedDatingUiComponent';
import StageUiComponent from './StageUiComponent';
import TeamHeroMenuUiComponent from './TeamHeroMenuUiComponent';
import TicketcodeUiComponent from './TicketcodeUiComponent';
import UserProfileComponent from './UserProfileUiComponent';
import VideoUiComponent from './VideoUiComponent';

const UIComponentElement = ({
  uiComponent,
  showControl,
  restrictWidth,
}: UiComponentElementInterface<ALL_COMPONENTS_INTERSECTION_TYPE> & {
  showControl?: boolean;
  restrictWidth?: boolean;
}) => {
  const { getMaxWidthForComponent } = usePagebuilder();
  const { isMobileView } = useMobileView();

  const componentElement = () => {
    let componentEl: JSX.Element = <></>;
    switch (uiComponent?.componentType) {
      case 'html':
        componentEl = <HTMLComponent uiComponent={uiComponent} />;
        break;
      case 'stage':
        componentEl = <StageUiComponent uiComponent={uiComponent} />;
        break;
      case 'ctabutton':
        componentEl = <CTAButtonUiComponent uiComponent={uiComponent} />;
        break;
      case 'boothlogolist':
        componentEl = <BoothLogos uiComponent={uiComponent} />;
        break;
      case 'presentationpreviewlist':
        componentEl = <PresentationPreviewList uiComponent={uiComponent} />;
        break;
      case 'margin':
        componentEl = <MarginComponent uiComponent={uiComponent} />;
        break;
      case 'booths':
        componentEl = <BoothsUiComponent uiComponent={uiComponent} />;
        break;
      case 'heromenu':
        componentEl = <HeroMenuUiComponent uiComponent={uiComponent} />;
        break;
      case 'network':
        componentEl = <NetworkComponent uiComponent={uiComponent} />;
        break;
      case 'presentation':
        componentEl = <PresentationUiComponent uiComponent={uiComponent} />;
        break;
      case 'appointment':
        componentEl = <AppointmentBookingUiComponent uiComponent={uiComponent} />;
        break;
      case 'media':
        componentEl = <MediaUiComponent uiComponent={uiComponent} />;
        break;
      case 'eventhome':
        componentEl = <EventHomeComponent uiComponent={uiComponent} />;
        break;
      case 'infobooth':
        componentEl = <InfoBoothUiComponent uiComponent={uiComponent} />;
        break;
      case 'queue':
        componentEl = <QueueComponent uiComponent={uiComponent} />;
        break;

      // deprecated and moved to image component
      case 'gallery':
        componentEl = <GalleryComponent uiComponent={uiComponent} />;
        break;
      case 'ticketcode':
        componentEl = <TicketcodeUiComponent uiComponent={uiComponent} />;
        break;
      case 'signupform':
        componentEl = <SignupFormComponent uiComponent={uiComponent} />;
        break;
      case 'countdown':
        componentEl = <CountdownComponent uiComponent={uiComponent} />;
        break;
      case 'photobooth':
        componentEl = <PhotoBoothUiComponent uiComponent={uiComponent} />;
        break;
      case 'agenda':
        componentEl = <AgendaUIComponent uiComponent={uiComponent} />;
        break;
      case 'challenge':
        componentEl = <ChallengeComponent uiComponent={uiComponent} />;
        break;
      case 'video':
        componentEl = <VideoUiComponent uiComponent={uiComponent} />;
        break;
      case 'socialmedia':
        componentEl = <SocialMediaComponent uiComponent={uiComponent} />;
        break;
      case 'userprofile':
        componentEl = <UserProfileComponent uiComponent={uiComponent} />;
        break;
      case 'speakers':
        componentEl = <SpeakersUiComponent uiComponent={uiComponent} />;
        break;
      case 'image':
        componentEl = <ImageUiComponent uiComponent={uiComponent} />;
        break;
      case 'speeddating':
        componentEl = <SpeedDatingUiComponent uiComponent={uiComponent} />;
        break;
      case 'allMatches':
        componentEl = <AllMatchesUiComponent uiComponent={uiComponent} />;
        break;
      case 'qa':
        componentEl = <QAUiComponent uiComponent={uiComponent} />;
        break;
      case 'poll':
        componentEl = <PollUiComponent uiComponent={uiComponent} />;
        break;
      case 'eventslist':
        componentEl = <EventsListUiComponent uiComponent={uiComponent} />;
        break;
      case 'teamheromenu':
        componentEl = <TeamHeroMenuUiComponent uiComponent={uiComponent} />;
        break;
      case 'column':
        componentEl = <ColumnUiComponent uiComponent={uiComponent} />;
        break;
      case 'divider':
        componentEl = <DividerUiComponent uiComponent={uiComponent} />;
        break;
      default:
        componentEl = <></>;
        break;
    }
    return componentEl;
  };

  return (
    <>
      <AdjustableSizeWrapper uiComponent={uiComponent} showControl={showControl}>
        <div className="justify-center element-wrapper">{componentElement()}</div>
      </AdjustableSizeWrapper>

      <style jsx>
        {`
          .element-wrapper {
            ${getMaxWidthForComponent(uiComponent)}
            ${restrictWidth && !uiComponent?.isFullWidth ? (isMobileView() ? 'width: 95%;' : 'width: 80%;') : 'width: 100%;'}
          }
        `}
      </style>
    </>
  );
};
export default UIComponentElement;
